import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=24bb30ff&scoped=true"
import script from "./UserHistory.vue?vue&type=script&lang=js"
export * from "./UserHistory.vue?vue&type=script&lang=js"
import style0 from "./UserHistory.vue?vue&type=style&index=0&id=24bb30ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb30ff",
  null
  
)

export default component.exports